import { FormSubmissionModel } from '../airtable/models/formSubmission';

export const formSubmissionsApi = {
  submit: async (formData) => {
    try {
      const response = await FormSubmissionModel.create(formData);
      return response;
    } catch (error) {
      throw new Error(`Failed to submit form: ${error.message}`);
    }
  },

  getAll: async () => {
    try {
      const submissions = await FormSubmissionModel.getAll();
      return submissions;
    } catch (error) {
      throw new Error(`Failed to fetch submissions: ${error.message}`);
    }
  },
};
